import { NavConfigSchema, type NavConfig } from '@hud/core';
import { registerWidget, type WidgetProps } from '../registry.js';
import './nav.css';

/** Links to other dashboards. Absolute URLs open externally; bare names are hash routes. */
function Nav({ config }: WidgetProps<NavConfig>) {
  return (
    <nav class={`hud-nav hud-nav--${config.direction}`}>
      {config.links.map((link) => {
        const external = /^(https?:)?\/\//.test(link.to);
        return external ? (
          <a
            class="hud-nav__link"
            key={link.to}
            href={link.to}
            target="_blank"
            rel="noreferrer noopener"
          >
            {link.label}
          </a>
        ) : (
          <a class="hud-nav__link" key={link.to} href={`#/${link.to}`}>
            {link.label}
          </a>
        );
      })}
    </nav>
  );
}

registerWidget({
  type: 'nav',
  schema: NavConfigSchema,
  component: Nav,
});
